import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    fetchReceitasFinanceirasBegin: null,
    fetchReceitasFinanceirasSuccess: ['payload'],
    fetchReceitasFinanceirasFailure: null,
})

export const fetchReceitasReport = componentState => dispatch => {
    dispatch(Creators.fetchReceitasFinanceirasBegin())
    return getHTTPClient()({
        method: 'POST',
        url: '/reports/receitas-financeiras',
        data: componentState
    })
    .then(response => dispatch(Creators.fetchReceitasFinanceirasSuccess(response.data)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
                showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.fetchReceitasFinanceirasFailure())
    })
}